export const buildVersion = {
  version: '1.1',
  buildNumber: 390,
  commit: 'a7e87cddb',
};
